/** 口播模式，短视频/播客，文案 120 字符阶梯 */
const LIVE_SCRIPT_COUNT = 120;

/** 口播模式，音频预览生成，文案 1000 字符阶梯 */
const LIVE_SCRIPT_AUDIO_PREVIEW_COUNT = 1000;

/** 视频时长，15秒阶梯 */
const VIDEO_DURATION_STEP = 15;

export {
  LIVE_SCRIPT_COUNT,
  LIVE_SCRIPT_AUDIO_PREVIEW_COUNT,
  VIDEO_DURATION_STEP,
};